
import Vue from 'vue'
export default Vue.extend({
    props: {
        tag: {
            required: true,
            type: String
        },
        removable: {
            required: false,
            default: false
        },
        clickable: {
            required: false,
            default: false
        }
    },
    methods: {
        emitClick()  {
            if (this.clickable) {
                this.$emit("click", this.tag);
            }
        },
        emitRemove()  {
            this.$emit("remove", this.tag);
        }
        
    }
    
})
